import React from 'react';
import SectionTitle from '../../components/Common/SectionTitle';

const CorporateLegacy = ({ summaryOnly = false }) => {
    return (
        <div id="rs-corporate-legacy" className="rs-corporate-legacy style3 pt-120 pb-120 md-pt-80 md-pb-80">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="Corporate Legacy"
                    titleClass="title testi-title"
                    title={summaryOnly ? "A Legacy of Proven Delivery" : "A Legacy of High-Stakes Events, Delivered"}
                />

                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <p className="lead">
                            Bizu LLC brings a battle-tested operational playbook built on predecessor expertise. We turn complex requirements into flawless execution—secure conferences, federal ceremonies, international programs, and high-profile meetings—delivered on time and within budget.
                        </p>

                        <div className="row mt-30">
                            <div className="col-md-4">
                                <div className="legacy-card">
                                    <div className="card-icon"></div>
                                    <h6 className="card-title">Proven Foundation</h6>
                                    <p className="card-body">Built on predecessor experience dating to 1989 (PSA public record: "28+ years").</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="legacy-card">
                                    <div className="card-icon"></div>
                                    <h6 className="card-title">Certifications & Trust</h6>
                                    <p className="card-body">Recognized government certifications: WOSB, WBENC, HUBZone, Seaport-e.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="legacy-card">
                                    <div className="card-icon"></div>
                                    <h6 className="card-title">Operational Reach</h6>
                                    <p className="card-body">Proven delivery across federal agencies, multi-site programs, and international coordination.</p>
                                </div>
                            </div>
                        </div>

                        <div className="rs-stats style2 mt-40 mb-30">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="stat-item text-center">
                                        <span className="stat-number">1989</span>
                                        <p className="stat-label">Founded (PSA public record)</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="stat-item text-center">
                                        <span className="stat-number">28+</span>
                                        <p className="stat-label">Years (PSA public record)</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="stat-item text-center">
                                        <span className="stat-number">Reported</span>
                                        <p className="stat-label">40+ yrs, 90+ countries, 4,000 events/yr*</p>
                                    </div>
                                </div>
                            </div>
                            <p className="small muted mt-10">*Reported by predecessor sources; presented here as reported legacy context and not as direct contract attribution to Bizu LLC.</p>
                        </div>

                        <p className="muted mt-20">
                            Note: These statements reflect predecessor (PSA) publicly reported experience and certifications. They are provided as predecessor/successor context and leadership continuity. Bizu LLC does not claim to have performed predecessor contracts unless documented novation or assignment is provided; contract attribution will be made in proposals per solicitation rules and applicable legal documentation.
                        </p>

                        {summaryOnly && (
                            <div className="btn-part text-center mt-30">
                                <a className="readon discover more" href="/past-performance">View Past Performance & References</a>
                            </div>
                        )}

                        {!summaryOnly && (
                            <>
                                <hr className="mt-40 mb-40" />

                                <h4 className="mt-10">Comprehensive Capabilities</h4>
                                <p className="small muted">Condensed from predecessor capability statements to reflect the breadth Bizu LLC inherits and amplifies.</p>

                                <div className="capability-grid mt-20">
                                    <div className="capability-card">
                                        <h6>Workforce Solutions</h6>
                                        <ul>
                                            <li>Managed staffing, RPO, temp-to-hire</li>
                                            <li>Executive search & permanent placement</li>
                                            <li>Clearance & bilingual recruiting</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Program & Project Management</h6>
                                        <ul>
                                            <li>Program/Project management, PMO support</li>
                                            <li>Risk, schedule, and earned value management</li>
                                            <li>Budgeting, cost analysis, corrective action</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Management Consulting</h6>
                                        <ul>
                                            <li>Executive coaching & leadership development</li>
                                            <li>Organizational transformation & change management</li>
                                            <li>Business process reengineering & facilitation</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Information Technology</h6>
                                        <ul>
                                            <li>IT infrastructure & systems integration</li>
                                            <li>Database, network, and cybersecurity support</li>
                                            <li>EMR support and technology program management</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Facility & Operations</h6>
                                        <ul>
                                            <li>Facility management & operations</li>
                                            <li>Security, records, and fleet management</li>
                                            <li>On-site medical & emergency support</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Training & Development</h6>
                                        <ul>
                                            <li>Workforce development & e-learning</li>
                                            <li>PMP boot camps, EVM training</li>
                                            <li>Diversity, safety, and leadership programs</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Engineering & Technical</h6>
                                        <ul>
                                            <li>Engineering support & technical consulting</li>
                                            <li>Technical writing, grant writing, research support</li>
                                            <li>Scientific and technical staffing</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Healthcare & Medical</h6>
                                        <ul>
                                            <li>Healthcare staffing & EMR support</li>
                                            <li>Physician and nurse practitioner support</li>
                                            <li>Occupational health and medical program support</li>
                                        </ul>
                                    </div>

                                    <div className="capability-card">
                                        <h6>Federal Government Support</h6>
                                        <ul>
                                            <li>Federal program & contract support</li>
                                            <li>Meeting facilitation and executive advisory</li>
                                            <li>Program certification and administrative services</li>
                                        </ul>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CorporateLegacy;
